import Studio from "./index";
import Manage from "./manage-studio.vue";

// import middlewares
export default [
  {
    path: "/studio",
    component: Studio,
    name: "Studio",
  },
  {
    path: "/manage-studio/:id",
    component: Manage,
    name: "ManageStudio",
  }
];
